export default [
  {
    categoria: "Rodamientos Automotrices",
    productos: [
      {
        nombre: "Rigido de Bolas Automotriz",
        slug: "rigido-de-bolas-automotriz",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/rigido-de-bolas-automotriz.webp"),
      },
      {
        nombre: "Rodillos Cilindricos Automotriz",
        slug: "rodillos-cilindricos-automotriz",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/rodillos-cilindricos-automotriz.webp"),
      },
      {
        nombre: "De Agujas Automotriz",
        slug: "de-agujas-automotriz",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/de-agujas-automotriz.webp"),
      },
      {
        nombre: "Rodillos Cónicos Automotriz",
        slug: "rodillos-conicos-automotriz",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/rodillos-conicos-automotriz.webp"),
      },
      {
        nombre: "DAC",
        slug: "rodamiento-dac",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/rodamiento-dac.webp"),
      },
      {
        nombre: "Rodamiento de Bomba de Agua",
        slug: "rodamiento-de-bomba-de-agua",
        imagen: require("@/assets/images/productos-automotriz/rodamientos-automotrices/rodamiento-de-bomba-de-agua.webp"),
      },
    ],
  },
];
